<template>
  <a-modal
    v-model="visible"
    title="编辑项目信息"
    @ok="handleOk"
    cancelText="取消"
    okText="保存"
    wrapClassName="edit-project-message"
    @cancel="handleCancel"
  >
    <a-row style="border-bottom: 1px solid #e8e8e8; padding-bottom: 18px">
      <a-col :span="6" :offset="5">
        <div
          :class="[
            editProjectMessageType === 'basic'
              ? 'edit-project-message-tabs-active'
              : 'edit-project-message-tabs','showPoint']
          "
          @click="editMessageType('basic')"
        >
          基本信息
        </div>
      </a-col>
      <a-col :span="6" :offset="3">
        <div
          :class="[
            editProjectMessageType === 'config'
              ? 'edit-project-message-tabs-active'
              : 'edit-project-message-tabs','showPoint']
          "
          @click="editMessageType('config')"
        >
          配置信息
        </div>
      </a-col>
    </a-row>
    <a-row style="margin-top: 48px" v-show="editProjectMessageType === 'basic'">
       <a-col :span="24" :offset="0">
        <a-form-item
          label="项目标题"
          :labelCol="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input v-model="project.projectTitle" />
        </a-form-item>
      </a-col>
      <a-col :span="24" :offset="0">
        <a-form-item
          label="项目名称"
          :labelCol="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input v-model="project.projectName" />
        </a-form-item>
      </a-col>
      <a-col :span="24" :offset="0">
        <a-form-item
          label="项目介绍"
          :labelCol="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input v-model="project.projectDescription" />
        </a-form-item>
      </a-col>
    </a-row>
    <a-row
      style="margin-top: 48px"
      v-show="editProjectMessageType === 'config'"
    >
      <a-col :span="23" :offset="1" v-if="false">
        <a-form-item
          label="数据库JDBC URL"
          :labelCol="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input v-model="nowUrl" />
        </a-form-item>
      </a-col>
      <a-col :span="23" :offset="1">
        <a-form-item
          label="Swagger Spec"
          :labelCol="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input v-model="nowApi" />
        </a-form-item>
      </a-col>
    </a-row>
  </a-modal>
</template>
<script>
export default {
  name: "EditProjectModal",
  data() {
    return {
      visible: false,
      editApi: "",
      editUrl: "",
      nowUrl:"",
      nowApi: "",
    };
  },
  watch: {
    editProjectMessageVisible(value) {
      this.visible = value;
    },
    api(value) {
      this.nowApi = value;
      this.editApi = value ;

    },
    url(value) {
      this.nowUrl = value;
      this.editUrl = value ;
    },
  },
  props: {
    editProjectMessageVisible: {
      type: Boolean,
    },
    editProjectMessageType: {
      type: String,
    },
    project: {
      type: Object,
    },
    api: {
      type: String,
    },
    url: {
      type: String,
    },
  },
  methods: {
    handleOk(e) {
      console.log('项目',this.project)
      this.$emit("handleOk", this.project, this.nowApi, this.nowUrl);
    },
    editMessageType(value) {
      this.$emit("editMessageType", value);
    },
    handleCancel() {
      this.nowApi = this.editApi;
      this.nowUrl = this.editUrl;
      console.log(this.nowApi,this.editApi,this.nowUrl,this.editUrl)
      this.$emit("handleCancel");
    },
  },
};
</script>
<style scoped>
@import "./EditProjectModal.css";
</style>